import firebase from 'firebase/app';
import 'firebase/firestore';
import { firebaseConfig } from './firebaseConfig';

firebase.initializeApp(firebaseConfig);
const FIRESTORE = firebase.firestore();

export const getFirestoreUsers = async (user, fetchUpdated) => {
  //console.log('getFirestoreUsers', 'user', user);
  //console.log('b', `${user?.business?.apiKey}-b-${user?.business?.businessid}`)
  try {
    FIRESTORE.collection('users')
      .where('b', '==', user?.apikey + '-b-' + user?.businessid)
      .orderBy('name')
      .onSnapshot((querySnapshot) => {
        const users = [];
        querySnapshot.docChanges().forEach((change) => {
          if (change.type !== 'removed') {
            users.push(change.doc.data());
          }
        });
        fetchUpdated(users);
      });
  } catch (error) {
    throw error;
  }
};
